{
  "id": "elves",
  "name": "Elves",
  "unitNames": {
    "worker": "Gatherer",
    "melee": "Warden",
    "ranged": "Longbow"
  },
  "buildingNames": {
    "town-center": "Heartwood",
    "barracks": "Hall of Wardens"
  }
}
